import { IBuyTicketsSettings, defaultCalendarSettings } from '../../classes/buytickets';
import { ICalendarAppBaseText, defaultBaseText } from '../../classes/buytickets-text';
import { ActionType, IBuyTicketsStateAction } from '../../classes/buytickets-actions';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function calendarTextReducer(state: ICalendarAppBaseText = defaultBaseText, action: IBuyTicketsStateAction) {
    switch (action.type) {
        case ActionType.RequestText: {
            return { ...state, requesting: true } as ICalendarAppBaseText;
        }
        case ActionType.ReceiveText: {
            return { ...state, ...action.value, requesting: false, apiError: null } as ICalendarAppBaseText;
        }
        case ActionType.ErrorApiText: {
            console.log(action.value);

            return { ...state, ...action.value, requesting: false, apiError: action.value } as ICalendarAppBaseText;
        }
        default:
            return state;
    }
}
